"use client";

import type { DifficultyLevel } from "@/lib/game/types";
import type { UiIconId } from "@/lib/game/uiIcons";
import { GameIconButton, type GameTone } from "../game-ui";

const LEVELS: DifficultyLevel[] = ["easy", "medium", "hard"];

const LEVEL_ICONS: Record<DifficultyLevel, UiIconId> = {
  easy: "easy",
  medium: "medium",
  hard: "hard",
};

const LEVEL_TONES: Record<DifficultyLevel, GameTone> = {
  easy: "emerald",
  medium: "sky",
  hard: "rose",
};

interface DifficultyPickerProps {
  value: DifficultyLevel;
  onChange: (level: DifficultyLevel) => void;
  compact?: boolean;
}

export function DifficultyPicker({ value, onChange, compact }: DifficultyPickerProps) {
  return (
    <div
      className={compact ? "flex flex-wrap gap-2" : "flex flex-wrap gap-3"}
      role="group"
      aria-label="Difficulty"
    >
      {LEVELS.map((level) => {
        const active = value === level;
        return (
          <GameIconButton
            key={level}
            icon={LEVEL_ICONS[level]}
            tone={LEVEL_TONES[level]}
            size={compact ? "sm" : "md"}
            selected={active}
            onClick={() => onChange(level)}
          />
        );
      })}
    </div>
  );
}
